import { TypedDocumentNode } from '@apollo/client'
import { useMutation } from '@apollo/client/react'
import { AdminUpdateTranslationContentMutationDocument } from '@docpace/admin-graphql/dist/urql.types'
import { AdminUpdateTranslationContentMutationResultFragment, AdminUpdateTranslationContentMutationParams } from '@docpace/admin-graphql'

const typedAdminUpdateTranslationContentMutationDocument = AdminUpdateTranslationContentMutationDocument as TypedDocumentNode<AdminUpdateTranslationContentMutationResultFragment, Partial<AdminUpdateTranslationContentMutationParams>>

export function useAdminUpdateTranslationContentMutation(opts?: useMutation.Options<AdminUpdateTranslationContentMutationResultFragment, Partial<AdminUpdateTranslationContentMutationParams>>){
    return useMutation(typedAdminUpdateTranslationContentMutationDocument, opts)
}
